<template>
  <Container fullHeight dark>
    <div class="desktop">
      <div class="field">
        <img src="../assets/img/SlideButton.svg" @click="scroll('phoneCarousel', 'prev')">
      </div>
      <div class="content">
        <div
          class="slider"
          :class="{
            'last-slide': lastSlide,
            'first-slide': firstSlide
          }"
        >
          <VueSlickCarousel
            ref="phoneCarousel"
            :slidesToShow="4"
            :arrows="false"
            @beforeChange="changeHandler"
            swipeToSlide
            :responsive="responsive"
          >
            <Phone image="01.png">
              <p>Просто расскажи о своих пожеланиях, я сам создам сценарий</p>
            </Phone>
            <Phone image="02.png">
              <p>Создавай сценарии самостоятельно</p>
            </Phone>
            <Phone image="03.png">
              <p>Посмотри, какие сценарии я приготовил для тебя</p>
            </Phone>
            <Phone image="04.png">
              <p>По-моему, ты сегодня остался дома</p>
            </Phone>
            <Phone image="05.png">
              <h1><small>40%</small></h1>
              <p>энергосбережения</p>
            </Phone>
            <Phone image="06.png">
              <p>информация в кВт/час и рублях в режиме реального времени</p>
            </Phone>
            <Phone image="07.png">
              <p>Каждую минуту информация обновляется</p>
            </Phone>
            <Phone image="01.png">
              <p>Отключи "прожорливые" приборы</p>
            </Phone>
            <Phone image="02.png">
              <p>Я отключу все устройства после вашего ухода</p>
            </Phone>
            <Phone image="03.png">
              <h2>Выбери свой тариф</h2>
            </Phone>
            <Phone image="04.png">
              <p>Построй график по своему запросу</p>
            </Phone>
            <Phone image="05.png">
              <h1>100</h1>
              <p>
                Функций умного дома:
                <ul>
                  <li>свет</li>
                  <li>отопление</li>
                  <li>вентиляция</li>
                  <li>водоснабжение</li>
                  <li>мультимедиа</li>
                </ul>
              </p>
            </Phone>
            <Phone image="06.png">
              <p>Приоритет нагрузок по твоему сценарию</p>
            </Phone>
            <Phone image="07.png">
              <p>Изменение сценария в режиме реального времени без перекоммутирова-<br>ния и перепрограм-<br>мирования</p>
            </Phone>
            <Phone image="01.png">
              <h2>Создай свой умный дом</h2>
            </Phone>
            <Phone image="02.png">
              <p>Теперь ты в курсе, сколько потребляет твой холодильник</p>
            </Phone>
            <Phone image="03.png">
              <p>Ты получишь предупреждение об отключении электрогирлянды</p>
            </Phone>
            <Phone image="05.png">
              <p>Создаст эффект присутствия с неповторяемыми сценариями</p>
            </Phone>
            <Phone image="01.png">
              <p>Теперь твой пес может грызть проводку безопасно</p>
            </Phone>
            <Phone image="06.png">
              <p>Запрос разрешения на подключение к сети нового устройства</p>
            </Phone>
            <Phone image="07.png">
              <p>Знает все твои электрические устройства в лицо</p>
            </Phone>
            <Phone image="04.png">
              <p>Выбери музыку своего настроения</p>
            </Phone>
            <Phone image="02.png">
              <p>Вовремя предупредит о повреждении в сети</p>
            </Phone>
            <Phone image="03.png">
              <p>Ты точно знаешь, какая из розеток неисправна</p>
            </Phone>
            <Phone image="05.png">
              <h2>Журнал событий</h2>
            </Phone>
          </VueSlickCarousel>
        </div>
      </div>
      <div class="field">
          <img src="../assets/img/SlideButton.svg" @click="scroll('phoneCarousel')">
      </div>
    </div>
    <div class="mobile">
      <div class="slide">
        <Phone image="01.png">
          <p>Просто расскажи о своих пожеланиях, я сам создам сценарий</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="02.png">
          <p>Создавай сценарии самостоятельно</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="03.png">
          <p>Посмотри, какие сценарии я приготовил для тебя</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="04.png">
          <p>По-моему, ты сегодня остался дома</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="05.png">
          <h1><small>40%</small></h1>
          <p>энергосбережения</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="06.png">
          <p>информация в кВт/час и рублях в режиме реального времени</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="07.png">
          <p>Каждую минуту информация обновляется</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="01.png">
          <p>Отключи "прожорливые" приборы</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="02.png">
          <p>Я отключу все устройства после вашего ухода</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="03.png">
          <h2>Выбери свой тариф</h2>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="04.png">
          <p>Построй график по своему запросу</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="05.png">
          <h1>100</h1>
          <p>
            Функций умного дома:
            <ul>
              <li>свет</li>
              <li>отопление</li>
              <li>вентиляция</li>
              <li>водоснабжение</li>
              <li>мультимедиа</li>
            </ul>
          </p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="06.png">
          <p>Приоритет нагрузок по твоему сценарию</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="07.png">
          <p>Изменение сценария в режиме реального времени без перекоммутирова-<br>ния и перепрограм-<br>мирования</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="01.png">
          <h2>Создай свой умный дом</h2>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="02.png">
          <p>Теперь ты в курсе, сколько потребляет твой холодильник</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="03.png">
          <p>Ты получишь предупреждение об отключении электрогирлянды</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="05.png">
          <p>Создаст эффект присутствия с неповторяемыми сценариями</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="01.png">
          <p>Теперь твой пес может грызть проводку безопасно</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="06.png">
          <p>Запрос разрешения на подключение к сети нового устройства</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="07.png">
          <p>Знает все твои электрические устройства в лицо</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="04.png">
          <p>Выбери музыку своего настроения</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="02.png">
          <p>Вовремя предупредит о повреждении в сети</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="03.png">
          <p>Ты точно знаешь, какая из розеток неисправна</p>
        </Phone>
      </div>
      <div class="slide">
        <Phone image="05.png">
          <h2>Журнал событий</h2>
        </Phone>
      </div>
    </div>
  </Container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import Phone from '../components/Phone.vue'
import Container from '../components/Container.vue'

// optional style for arrows & dots
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'MyComponent',
  components: {
    VueSlickCarousel,
    Phone,
    Container
   },
  data: () => ({
    responsive: [{
      "breakpoint": 1250,
      "settings": {
        "slidesToShow": 3
      }
    },
    {
      "breakpoint": 800,
      "settings": {
        "slidesToShow": 2
      }
    },
    {
      "breakpoint": 640,
      "settings": {
        "infinite": false,
        "slidesToShow": 1,
        "swipeToSlide": false,
        "centerMode": true
      }
    }],
    length: 0,
    firstSlide: true,
    lastSlide: false
  }),
  methods: {
    changeHandler(oldSlideIndex,newSlideIndex) {
      let lastIndex = this.length - 1
      if (newSlideIndex === 0) {
        this.firstSlide = true
      } else if (newSlideIndex === lastIndex) {
        this.lastSlide = true
      } else {
        this.firstSlide = false
        this.lastSlide = false
      }
    },
    scroll(ref, direction) {
      let carousel = this.$refs[ref];
      if (direction == "prev") {
        carousel.prev()
      } else { carousel.next() }
    }
  },
  mounted() {
    this.length = this.$refs.phoneCarousel.$slots.default.length
  }
}
</script>

<style media="screen">
  @media screen and (max-width: 800px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .content {
      width: 100%;
    }
    .field {
      display: none;
    }
    .slider {
      position: absolute;
      top: 55%;
      width: 100%;
      transform: translateY(-50%);
    }
    .first-slide .phone-container {
      transform: translateX(-50px) scale(.9);
    }
    .last-slide .phone-container{
      transform: translateX(50px) scale(.9);
    }
  }
  @media screen and (min-width: 800px) {
    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }
    .content {
      width: 80%;
    }
    .field {
      width: 10%;
    }
    .slider {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
    }
  }
  .content {
    display: inline-block;
    position: relative;
    height: 100vh;
  }
  .mobile .slide {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 70vw;
    max-width: 280px;
    margin: 0 3%;
    /* height: 90vh; */
    /* border: 1px solid red; */
  }
  .mobile {
    /* width: auto; */
    position: relative;
    /* width: 100vw; */
    max-height: 100vh;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  /* .slider {
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
  } */
  .field {
    height: 100vh;
    position: relative;
  }
  .field:first-child { float: left; }
  .field:last-child { float: right; }
  .field img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    cursor: pointer;
  }
  .field:first-child img {
    transform: rotate(180deg) translate(50%,50%);
  }
</style>
